// src/components/common/SidebarProfileCard.js
// Maxula
// Carte profil COMPACTE (avatar rond) destinee a etre EPINGLEE en bas de la
// sidebar (hors zone scrollable) -> n'empiete plus sur les items du menu.
// scope = 'admin' | 'merchant'

import React from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { getAvatarUrl, getDisplayName, avatarOnError } from '../../utils/avatar';

const ROLE_LABEL = {
  admin: 'Administrateur',
  merchant: 'Marchand'
};

const SidebarProfileCard = ({ user, scope = 'merchant', to, onNavigate }) => {
  const name = getDisplayName(user);
  const avatar = getAvatarUrl(user, { size: 96 });
  const roleLabel = ROLE_LABEL[scope] || 'Compte';
  const profileTo = to || (scope === 'admin' ? '/admin/profile' : '/merchant/settings');

  return (
    <Link
      to={profileTo}
      onClick={() => typeof onNavigate === 'function' && onNavigate()}
      className="group flex items-center gap-2.5 rounded-xl border border-gray-100 bg-gradient-to-r from-primary-50 to-blue-50 p-2.5 hover:from-primary-100 hover:to-blue-100 transition-colors"
    >
      <span className="relative shrink-0">
        <img
          src={avatar}
          alt={name}
          onError={avatarOnError(user)}
          className="w-10 h-10 rounded-full object-cover ring-2 ring-white shadow"
        />
        <span
          className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"
          aria-hidden="true"
          title="En ligne"
        />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-gray-900 truncate" title={name}>
          {name}
        </span>
        <span className="block text-[11px] text-gray-500 truncate">{roleLabel}</span>
      </span>
      <FiExternalLink
        className="text-primary-500 opacity-70 group-hover:opacity-100 shrink-0"
        size={15}
        aria-hidden="true"
      />
    </Link>
  );
};

export default SidebarProfileCard;
